module.exports = __webpack_public_path__ + "img/ship404.4a3deaf9.png";